import { render, staticRenderFns } from "./RoundedBox.vue?vue&type=template&id=7982d12e&"
import script from "./RoundedBox.vue?vue&type=script&lang=js&"
export * from "./RoundedBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports